<h3>Edit category</h3>
<div>
	<app-select [(ngModel)]="selectedSubType" class="mt-5">
		<option *ngFor="let type of subTypes" [value]="type.type">
			{{ type.friendlyType }}
		</option>
	</app-select>
</div>
<div class="flex justify-between mt-10">
	<app-button btn="tertiary" size="small" (click)="close()">Cancel</app-button>
	<app-button size="small" (click)="save()">Save</app-button>
</div>
